import { RequestContext } from "./http/http";
export class ServerConfiguration {
    url;
    variableConfiguration;
    constructor(url, variableConfiguration) {
        this.url = url;
        this.variableConfiguration = variableConfiguration;
    }
    setVariables(variableConfiguration) {
        Object.assign(this.variableConfiguration, variableConfiguration);
    }
    getConfiguration() {
        return this.variableConfiguration;
    }
    getUrl() {
        let replacedUrl = this.url;
        for (const key in this.variableConfiguration) {
            var re = new RegExp("{" + key + "}", "g");
            replacedUrl = replacedUrl.replace(re, this.variableConfiguration[key]);
        }
        return replacedUrl;
    }
    makeRequestContext(endpoint, httpMethod, signal) {
        return new RequestContext(this.getUrl() + endpoint, httpMethod, signal);
    }
}
export const server1 = new ServerConfiguration("", {});
export const servers = [server1];
